"use client";

export default function LoginButton(props: any) {
  return(
    !props.loggedin ?
    <button className="py-0 px-1 text-xs bg-blue-300"
      onClick={(e: any) => {
        props.onEvent({message: "Login", params: {}});
      }}>
      Login
    </button>
    :
    <button className="py-0 px-1 text-xs bg-blue-300"
      onClick={(e: any) => {
        props.onEvent({message: "Logout", params: {}});
      }}>
      Logout
    </button>
  )
}
